import { useEffect, type RefObject } from 'react';

/**
 * 浮层的收起：Esc，或者点到浮层以外的任何地方。
 *
 * 用 pointerdown 而不是 click——否则触发这个浮层的那个按钮的 click
 * 会紧接着把刚收起的浮层又打开一次。
 */
export function useDismissOnOutside(
  box: RefObject<HTMLElement | null>,
  onDismiss: () => void,
): void {
  useEffect(() => {
    const onKey = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') onDismiss();
    };
    const onPointerDown = (event: PointerEvent): void => {
      if (box.current !== null && !box.current.contains(event.target as Node)) onDismiss();
    };
    window.addEventListener('keydown', onKey);
    window.addEventListener('pointerdown', onPointerDown);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('pointerdown', onPointerDown);
    };
  }, [box, onDismiss]);
}
